// src/belediye/components/utils/downloadFile.js

function pickFilenameFromUrl(url) {
  try {
    const u = new URL(url, window.location.origin);
    const last = u.pathname.split("/").filter(Boolean).pop();
    return last || "dosya";
  } catch {
    const parts = String(url).split("?")[0].split("#")[0].split("/");
    return parts[parts.length - 1] || "dosya";
  }
}

function normalizeFilename(name, fallbackExt) {
  const safe = (name || "dosya").trim();
  if (!safe) return `dosya${fallbackExt || ""}`;
  // uzantı yoksa ekle (opsiyonel)
  if (fallbackExt && !/\.[a-z0-9]{2,6}$/i.test(safe)) return `${safe}${fallbackExt}`;
  return safe;
}

/**
 * Content-Disposition header'ından filename çek
 * Ör: attachment; filename="report.xlsx"
 * Ör: attachment; filename*=UTF-8''report%20v1.xlsx
 */
export function pickFilenameFromContentDisposition(contentDisposition) {
  if (!contentDisposition) return null;

  // filename*=UTF-8''...
  let match = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(contentDisposition);
  if (match?.[1]) {
    try {
      return decodeURIComponent(match[1].replace(/["']/g, "").trim());
    } catch {
      return match[1].replace(/["']/g, "").trim();
    }
  }

  // filename="..."
  match = /filename\s*=\s*("?)([^";]+)\1/i.exec(contentDisposition);
  if (match?.[2]) return match[2].trim();

  return null;
}

/**
 * Blob/ArrayBuffer indir
 * - Redux thunk sonucunda gelen blob’ları indirmek için idealdir.
 */
export function downloadBlob(blobOrArrayBuffer, filename = "dosya", fallbackExt = "") {
  if (!blobOrArrayBuffer) return;

  const isBlob = typeof Blob !== "undefined" && blobOrArrayBuffer instanceof Blob;
  const blob = isBlob ? blobOrArrayBuffer : new Blob([blobOrArrayBuffer]);

  const finalName = normalizeFilename(filename, fallbackExt);

  const blobUrl = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = finalName;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();

  a.remove();
  window.URL.revokeObjectURL(blobUrl);
}

/**
 * Axios blob response indir
 * - responseType: "blob" ile gelen axios response’u doğrudan indirir
 * - Header’dan filename alır; yoksa fallback kullanır
 */
export function downloadAxiosBlobResponse(response, fallbackFilename = "dosya.xlsx") {
  if (!response) return;

  const cd =
    response?.headers?.["content-disposition"] ||
    response?.headers?.["Content-Disposition"];

  const headerName = pickFilenameFromContentDisposition(cd);

  const guessedExt =
    String(headerName || fallbackFilename).toLowerCase().endsWith(".xlsx") ? ".xlsx" : "";

  const finalName = normalizeFilename(headerName || fallbackFilename, guessedExt || ".xlsx");

  downloadBlob(response.data, finalName, ".xlsx");
}

/**
 * downloadFile(url, opts)
 * - Cross-domain download için fetch+blob kullanır
 * - Eğer sunucu CORS izin vermiyorsa fetch patlar → fallback verir (yeni sekme)
 */
export async function downloadFile(url, opts = {}) {
  const {
    filename,
    token, // gerekiyorsa Bearer
    headers = {},
    withCredentials = false, // cookie gerekiyorsa true
    fallbackToOpen = true, // CORS fail olursa yeni sekme
  } = opts;

  if (!url) return;

  const guessed = pickFilenameFromUrl(url);

  const lower = guessed.toLowerCase();
  const ext =
    lower.endsWith(".pdf") ? ".pdf"
    : lower.endsWith(".xlsx") ? ".xlsx"
    : lower.match(/\.(png|jpe?g|webp|gif)$/) ? ""
    : ""; // istersen default uzantı ekleyebilirsin

  const finalName = normalizeFilename(filename || guessed, ext);

  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...headers,
      },
      credentials: withCredentials ? "include" : "same-origin",
    });

    if (!res.ok) {
      throw new Error(`Download failed: ${res.status} ${res.statusText}`);
    }

    const blob = await res.blob();
    downloadBlob(blob, finalName, ext);
  } catch (err) {
    

    // CORS hatasında tarayıcı fetch'i bloklar. Frontend tek başına aşamaz.
    // Yine de kullanıcıya erişim sağlamak için fallback:
    if (fallbackToOpen) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  }
}
